import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTable from "./en-us/table.json";

export const localizationEnUsDelivery = {
  ...localizationEnUsHeader,
  ...localizationEnUsTable,
};
